import type React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { Button } from "components/Button";
import { InfoMessage } from "components/InfoMessage/InfoMessage";
import { ParagraphLarge } from "styles/elements/Texts";

export const NotFoundPathMessage: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation("common");

  return (
    <InfoMessage
      dataCy="not-found-path-message"
      icon="fas fa-map-marker-question"
      title={t("notFoundPath.title", "Not existing path")}
    >
      <ParagraphLarge marginBottom={5}>
        {t("notFoundPath.message", "The page you're trying to access does not exist.")}
      </ParagraphLarge>
      <Button dataCy="return-to-prev-page-button" onClick={() => navigate(-1)} variant="secondary">
        {t("notFoundPath.button.goBack", "Go back to previous page")}
      </Button>
    </InfoMessage>
  );
};
